import { Box, Button, Divider } from '@material-ui/core';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCartOutlined';
import {
  FetchWsCatalogueProductTypes,
  fetchWsCatalogueProducts,
} from '@src/reducers/wsCatalogue';
import { TimelineEvent } from '@src/types';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

interface IChatMessageWsCatalogueShoppingCartWrapper {
  message: Partial<TimelineEvent>;
}

export type IChatMessageWsCatalogueShoppingCart =
  IChatMessageWsCatalogueShoppingCartWrapper & {
    labels: { [key: string]: string };
    handleClickDetail: (id: string, catalogId: string) => void;
  };

const ChatMessageWsCatalogueShoppingCartWrapper: React.FC<
  IChatMessageWsCatalogueShoppingCartWrapper
> = ({ message }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const labels = {
    button: formatMessage({ id: 'Ws.Catalogue.shoppingCart.see.button' }),
    title: formatMessage({ id: 'Ws.Catalogue.shoppingCart.title.text' }),
    body: formatMessage({ id: 'Ws.Catalogue.shoppingCart.body.text' }),
    shopingCartTitle: formatMessage({
      id: 'Ws.Catalogue.shoppingCart.message.title',
    }),
  };
  return (
    <ChatMessageWsCatalogueShoppingCart
      message={message}
      labels={labels}
      handleClickDetail={(ids, catalogId) => {
        if (!message.shoppingCart) throw new Error('No shopping cart');
        dispatch(
          fetchWsCatalogueProducts({
            retailerIds: ids,
            catalogId,
            type: FetchWsCatalogueProductTypes.CART,
            shoppingCart: {
              ...message.shoppingCart,
              date: message.sendingTime || +Date.now(),
            },
          })
        );
      }}
    />
  );
};

const ChatMessageWsCatalogueShoppingCart: React.FC<
  IChatMessageWsCatalogueShoppingCart
> = ({ message, labels, handleClickDetail }) => {
  const { shoppingCart } = message;
  if (!shoppingCart) return null;
  const {
    mainImage,
    totalProducts,
    totalPrice,
    totalPriceCurrencySymbol,
    catalogId,
    productQuantity,
  } = shoppingCart;
  const { button, title, body, shopingCartTitle } = labels;
  const ids = Object.keys(productQuantity).join(',');

  return (
    <Box minWidth={349}>
      <Box display="flex" mb="8px" fontSize="12px" style={{ gap: '16px' }}>
        <img
          src={mainImage}
          alt=""
          style={{
            objectFit: 'contain',
            width: '100%',
            height: '100%',
            maxWidth: '65px',
            maxHeight: '65px',
            borderRadius: '8px',
          }}
        />
        <Box
          display="flex"
          justifyContent="flex-start"
          flexDirection="column"
          alignSelf="center"
        >
          <Box color="#000" fontWeight={500} fontSize={14}>
            {shopingCartTitle}
          </Box>
          <Box color="#000" fontWeight={500}>
            {totalProducts} {title}
          </Box>

          <Box display="flex" color="rgba(0, 0, 0, 0.40)" alignItems="center">
            <ShoppingCartIcon
              color="inherit"
              style={{ width: '16px', height: '16px', marginRight: '4px' }}
            />
            {totalPrice && (
              <Box>
                {totalPriceCurrencySymbol || ''} {totalPrice} ({body})
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      <Divider style={{ width: '95%' }} variant="fullWidth" />
      <Box textAlign="left">
        <Button
          style={{
            padding: '2px 8px',
            height: '22px',
            fontSize: '12px',
            fontWeight: '600px',
            marginTop: '16px',
            borderRadius: '4px',
            justifyContent: 'center',
          }}
          color="primary"
          variant="contained"
          onClick={() => handleClickDetail(ids, catalogId)}
        >
          {button}
        </Button>
      </Box>
    </Box>
  );
};

export default ChatMessageWsCatalogueShoppingCartWrapper;
